import React from 'react';
import { useHistory } from 'react-router';

import HttpLedger from 'src/components/HttpLedger';
import EmptyState from 'src/components/EmptyState';

import { PerspectiveType, Widget } from 'src/types';
import { PERSPECTIVE_DETAILS_BY_PERSPECTIVE_TYPE } from 'src/views/constants/perspectiveConstants';
import {
  FOR_USER,
  RESOURCE_DETAILS_BY_RESOURCE_TYPE
} from 'src/views/constants/tableRendererConstants';
import { LedgerColumn } from '../../../../../components';

// might make sense to move this into the backend and then sign it
const buildUrl = (widget: Widget, workflowId: string, engagementId: string, perspectiveType: PerspectiveType) => {
  // @ts-ignore
  const resourceDetails = RESOURCE_DETAILS_BY_RESOURCE_TYPE[widget.data.resourceType];

  const urlDomain = PERSPECTIVE_DETAILS_BY_PERSPECTIVE_TYPE[perspectiveType].urlResource;
  const { urlResource } = resourceDetails; // workflows or engagements

  let url: any;
  if (engagementId) {
    url = `/automatic/${urlDomain}/${engagementId}/${urlResource}/`; // /automatic/engagements/1/tasks/
  } else {
    url = `/automatic/${urlDomain}/${workflowId}/${urlResource}/`; // /automatic/engagements/1/tasks/
  }

  // @ts-ignore
  widget.data.filters.forEach(({ type }: { type: string }) => {
    if (type === FOR_USER) {
      url += 'for-user/';
    }
  });

  resourceDetails.filters.forEach(({
    type
  }: any) => {
    if (type !== FOR_USER) {
      // todo append querystring filters here
    }
  });
  // get resource
  // get context
  // handle filters

  return url;
};

interface Props {
  widget: Widget,
  perspectiveType: PerspectiveType,
  workflowId: string,
  engagementId: string,
  actions: React.ReactNode | null,
  buildRoute: any,
  ledgerColumns: LedgerColumn[],
}

const LedgerRenderer = ({
  widget,
  perspectiveType,
  workflowId,
  engagementId,
  actions,
  ledgerColumns
}: Props) => {
  const {
    isPaginated, isSearchable, isSortable
  } = widget.data;

  return (
    <HttpLedger
      url={buildUrl(widget, workflowId, engagementId, perspectiveType)}
      columns={ledgerColumns}
      emptyState={<EmptyState />}
      isPaginated={isPaginated}
      isSearchable={isSearchable}
      isSortable={isSortable}
      actions={actions}
    />
  );
};

export default LedgerRenderer;
